"use strict";
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.weightableAttributeNames = void 0;
exports.validateWeights = validateWeights;
const WeightMethod_1 = require("./WeightMethod");
/**
 * This is for interview objects that can be individually weighted after validation, using a specific weight method.
 */
exports.weightableAttributeNames = ['_weights'];
function validateWeights(_weights) {
    const errors = [];
    if (_weights !== undefined && !Array.isArray(_weights)) {
        errors.push(new Error('Weightable validateWeights: _weights should be an array'));
    }
    else if (_weights !== undefined && Array.isArray(_weights) && _weights.length > 0) {
        for (let i = 0, countI = _weights.length; i < countI; i++) {
            const _weight = _weights[i];
            if (_weight !== undefined && (typeof _weight.weight !== 'number' || _weight.weight < 0)) {
                errors.push(new Error(`Weightable validateWeights: weight at index ${i} must be a positive number`));
            }
            else if (_weight !== undefined &&
                _weight.method !== undefined &&
                !(_weight.method instanceof WeightMethod_1.WeightMethod)) {
                errors.push(new Error(`Weightable validateWeights: method at index ${i} must be an instance of WeightMethod`));
            }
        }
    }
    return errors;
}
//# sourceMappingURL=Weight.js.map